module.exports = __webpack_public_path__ + "media/virtualStagingSlider/virtualStagingSlider6Post-2f804549.jpeg";